module.exports = __webpack_public_path__ + "img/5.69bba60a.jpg";